import React from "react";
import { makeStyles, createStyles, Button } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import { VENUES_OVERVIEW } from "../../../const/URL.const";
import { ICreateVenue, useCreateNewVenue } from "../../../hooks/useCreateNewVenue";
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import { HubSpotSetUpStages } from "./types";
import { useUserLogout } from "../../../hooks/useUserLogout";

interface IWelcomeCreateVenueProps {
    data: ICreateVenue;
    leadId: string;
}

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            "&p":{
                fontFamily:" Open Sans",
                fontStyle: "normal",
                fontSize: "1.125rem",
                lineHeight: "1.5625rem",
            },
            "&>p:first-child":{
                fontWeight: "normal",
                color: "#616161",
                marginBottom:"0.9375rem"
            },
            "&>p:last-child":{
                fontWeight: 600,
                color: "#212121",
                margin:0
            }
        },
    }))

export function WelcomeCreateVenue({ data, leadId }: IWelcomeCreateVenueProps) {
    const { createVenue } = useCreateNewVenue();
    const [isCompleted, setIsCompleted] = useState(false);
    const [isError, setIsError] = useState(false);
    const classes = useStyles();
    const { t } = useTranslation();
    const { logout } = useUserLogout();
    const { callAPI } = useAPIV2(APIExtensions.registration, { query: `leads/${leadId}`, onMountDisabled: true })
    useEffect(() => {
        //@ts-ignore
        createVenue(data, false).then(() => {
            if (leadId) {
                callAPI(HTTPMethods.PATCH, {
                    body: {
                        set_up_stage: HubSpotSetUpStages.SIGNED_IN,
                        onboarding_source: data.venue_data.onboarding_source
                    }
                })
            }
            // history.replace(PROFILE_DETAILS_URL)
            // window.location.re
            setIsCompleted(true);
        }).catch((e) => {
            console.log(e,"Venue Creation Error");
            setIsError(true);
        })
        //eslint-disable-next-line
    }, [])

    if (isCompleted) {
        return <Redirect to={VENUES_OVERVIEW} />
    }

    if (isError) {
        return <>
            <div className={classes.root}>
                <p>{t('signup.welcome.venueCreateError')}</p>
                <p>support@yoello.com</p>
            </div>
            <Button onClick={logout} color="default">{t('misc.logout')}</Button>
        </>
    }

    return <div></div>;
}